import { mapState } from "vuex";
import type { ICurrency } from "@/models/constants";
import type { IState } from "@/store";

export default {
  computed: {
    ...mapState({
      brandCurrencyId: (state: IState): ICurrency["id"] =>
        state.brand.currency_id
    })
  }
};
